module.exports = __webpack_public_path__ + "static/media/image4.d63c6397.jpg";